/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @hrs 25/12/2023
 */

import React, { useContext, useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation } from "swiper";
import { isMobile } from 'react-device-detect';
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_HOURS } from '../../Pages/CheckoutPage';

import styles from "./NoHrsSelect.module.css"

const NoHrsSelect = ({ noHrs }) => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);
    const hrsPrevRef = useRef(null);
    const hrsNextRef = useRef(null);

    useEffect(() => {
        noHrs && dispatch({ type: SET_HOURS, payload: noHrs[0].noHrsId})
    }, [noHrs])

    const onHoursSelect = (val) => {
        dispatch({ type: SET_HOURS, payload: val})
    }

    return (
        <div className={styles.selectionContainer}>
            <Swiper
                slidesPerView={isMobile ? 5 : 9}
                spaceBetween={10}
                freeMode={true}
                modules={[Navigation]}
                className={styles['sample-slider']}
                navigation={{
                    prevEl: hrsPrevRef.current,
                    nextEl: hrsNextRef.current,
                }}
            >
                {noHrs?.map(hrs => (
             
                    <SwiperSlide
                    
                        key={hrs.noHrsId}
                        className={styles.hrsContainer}
                    >
                        <div
                            onClick={() => onHoursSelect(hrs.noHrsId)}
                            className={`${styles.numberButton} ${checkoutData.noHrs == hrs.noHrsId && styles.numberButtonSelected}`}
                        >
                            {hrs.noHrs}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div ref={hrsPrevRef} className="swiper-button-prev"></div>
            <div ref={hrsNextRef} className="swiper-button-next"></div>
        </div>
    )
}

export default NoHrsSelect